<template>
  <div class="coming-soon">
    <h1>Coming Soon</h1>
    <p>The website is under construction. Please check back later!</p>
    <div class="auth-form">
      <h2>Enter Credentials to Access the Website</h2>
      <input
          type="text"
          v-model="username"
          placeholder="Enter Username"
      />
      <input
          type="password"
          v-model="password"
          placeholder="Enter Password"
      />
      <button @click="authenticate">Submit</button>
      <p v-if="error" class="error">{{ error }}</p>
    </div>
  </div>
</template>

<script>
import {authenticate} from "@/router";

export default {
  name: "ComingSoon",
  data() {
    return {
      username: "",
      password: "",
      error: null,
    };
  },
  methods: {
    authenticate() {
      if (this.username === "DevilsArm" && this.password === "DevilsMistress") {
        authenticate(); // Set isAuthenticated to true
        this.$router.push("/home");
      } else {
        this.error = "Invalid username or password.";
      }
    },
  },
};
</script>

<style scoped>
.coming-soon {
  text-align: center;
  padding: 50px;
  background-color: #333;
  color: white;
  min-height: 100vh;
}

.auth-form {
  margin-top: 20px;
}

input {
  display: block;
  margin: 10px auto;
  padding: 10px;
  width: 80%;
  max-width: 300px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

button {
  padding: 10px 20px;
  background-color: crimson;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

button:hover {
  background-color: darkred;
}

.error {
  color: crimson;
  margin-top: 10px;
}
</style>
